import axios from '~/utils/axiosInstance';

export interface AssignToInvestorParams {
  investorId: string;
  nrsFee: number;
  nrsFeeUnit: string;
  buyerStorageFee?: number | null;
  buyerStorageFeeUnit?: string;
  sellerFee?: number | null;
  sellerFeeUnit?: string;
  sellerStorageFee?: number | null;
  sellerStorageFeeUnit?: string;
}

/** OpenAPI expects hash id strings; form widgets may send numbers. */
function withStringInvestorId<T extends { investorId?: string | number }>(data: T): T {
  if (data.investorId === undefined || data.investorId === null) return data;
  return { ...data, investorId: String(data.investorId) };
}

export interface UpdateInvestorQueueParams {
  investorId: string;
  nrsFee?: number;
  nrsFeeUnit?: string;
  buyerStorageFee?: number | null;
  buyerStorageFeeUnit?: string;
  sellerFee?: number | null;
  sellerFeeUnit?: string;
  sellerStorageFee?: number | null;
  sellerStorageFeeUnit?: string;
  status?: string;
  hasDocAccess?: boolean;
}

export const assignProjectToInvestor = async function (id: string, data: AssignToInvestorParams) {
  const response = await axios.post(`/admin/projects/${id}/invitations/assign`, withStringInvestorId(data));
  return response.data;
};

export const unassignProjectFromInvestor = async function (id: string, {investorId}: {investorId: string}) {
  const response = await axios.post(`/admin/projects/${id}/invitations/unassign`, withStringInvestorId({ investorId }));
  return response.data;
};

export const updateInvestorInProjectQueue = async function (id: string, data: UpdateInvestorQueueParams) { 
  const response = await axios.patch(`/admin/projects/${id}/invitations/update`, withStringInvestorId(data));
  return response.data;
};

export const assignPortfolioToInvestor = async function (id: string, data: AssignToInvestorParams) {
  const response = await axios.post(`/admin/portfolios/${id}/invitations/assign`, withStringInvestorId(data));
  return response.data;
};

export const unassignPortfolioFromInvestor = async function (id: string, {investorId}: {investorId: string}) {
  const response = await axios.post(`/admin/portfolios/${id}/invitations/unassign`, withStringInvestorId({ investorId }));
  return response.data;
};

export const updateInvestorInPortfolioQueue = async function (id: string, data: UpdateInvestorQueueParams) { 
  const response = await axios.patch(`/admin/portfolios/${id}/invitations/update`, withStringInvestorId(data));
  return response.data;
};
